import { render, staticRenderFns } from "./DeleteReportDialog.vue?vue&type=template&id=612c4cf1"
import script from "./DeleteReportDialog.vue?vue&type=script&lang=js"
export * from "./DeleteReportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports